import * as React from 'react';
/**
 * Create a context and provider that don't need to have a defined value at
 * creation. Using React.createContext directly, means you have to check
 * for undefined values everywhere you use the context.
 */
export function buildContext() {
    const context = React.createContext(undefined);
    /**
     * @returns The wanted context or throws an error if undefined.
     */
    function useContext() {
        const ctx = React.useContext(context);
        if (ctx === undefined) {
            throw new Error('useContext needs a provider with a defined value');
        }
        return ctx;
    }
    return [useContext, context.Provider];
}
//# sourceMappingURL=buildContext.js.map